import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientobstericsData, PatientobstericsMst, PatientobstericsreasonForProcedure } from '../../../interfaces/masters/patientobsterics';
import { PatientobstericsApi } from '../api/patientobsterics.api';

@Injectable()
export class PatientobstericsService extends PatientobstericsData{

 
  constructor(private api:  PatientobstericsApi) {
    super(); 
  }
  list(url: string): Observable<PatientobstericsMst[]> {
    return this.api.list(url);
  }

  listPatientobstericsreasonForProcedure(url: string): Observable<PatientobstericsreasonForProcedure[]> {
    return this.api.listPatientobstericsreasonForProcedure(url);
  }

  

  getById(url:string): Observable<PatientobstericsMst>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientobstericsMst): Observable<PatientobstericsMst> {
    return this.api.add(url,data);
  }

  createPatientobstericsreasonForProcedure(url: string, data: PatientobstericsreasonForProcedure[]): Observable<PatientobstericsreasonForProcedure[]> {
    return this.api.addPatientobstericsreasonForProcedure(url, data);
  }

  

  update(url: string, data:PatientobstericsMst): Observable<PatientobstericsMst> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  }
  deletePatientobstericsreasonForProcedure(url: string): Observable<boolean> {
    return this.api.deletedeletePatientobstericsreasonForProcedure(url);
  } 
  


}
